import React from 'react';

const statusStyles = {
  // Service Request statuses
  PENDING_ADMIN_ASSIGNMENT: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Pending' },
  ASSIGNED: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Assigned' },
  IN_PROGRESS: { bg: 'bg-indigo-100', text: 'text-indigo-700', label: 'In Progress' },
  WAITING_STUDENT: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Waiting' },
  COMPLETED: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Completed' },
  ON_HOLD: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'On Hold' },
  CANCELLED: { bg: 'bg-red-100', text: 'text-red-700', label: 'Cancelled' },

  // Payment statuses
  pending: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Pending' },
  processing: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Processing' },
  completed: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Completed' },
  failed: { bg: 'bg-red-100', text: 'text-red-700', label: 'Failed' },
  refunded: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Refunded' },

  // Generic statuses
  active: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Active' },
  inactive: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Inactive' },

  // Severity levels
  high: { bg: 'bg-red-100', text: 'text-red-700', label: 'High' },
  medium: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Medium' },
  low: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Low' },
  critical: { bg: 'bg-red-100', text: 'text-red-700', label: 'Critical' },

  // Default
  default: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Unknown' }
};

export function StatusBadge({ status, size = 'sm', className = '' }) {
  const style = statusStyles[status] || statusStyles.default;
  const label = style.label || status;

  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-[10px]',
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm'
  };

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${style.bg} ${style.text} ${sizeClasses[size]} ${className}`}
    >
      {label}
    </span>
  );
}

export default StatusBadge;
